import ZoomScrollModule from 'diagram-js/lib/navigation/zoomscroll/ZoomScroll';
ZoomScrollModule.prototype.scroll = () => { };
export default {
    __init__: ['zoomScroll'],
    zoomScroll: ['type', ZoomScrollModule],
};
